export const translations = {
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'عن المنظمة',
      news: 'الأخبار',
      media_center: 'المركز الإعلامي',
      mediaCenter: 'المركز الإعلامي',
      activities: 'الفعاليات والأنشطة',
      events_activities: 'الفعاليات والأنشطة',
      eventsActivities: 'الفعاليات والأنشطة',
      fields: 'مجالاتنا',
      heritage_life: 'تراثنا حياة',
      contact: 'تواصل معنا',
      admin: 'الإدارة',
      events: 'الفعاليات',
      seminars: 'الندوات',
      projects: 'المشاريع',
      gallery: 'المعرض',
      photo_gallery: 'معرض الصور',
      photoGallery: 'معرض الصور',
      video_gallery: 'معرض الفيديو',
      videoGallery: 'معرض الفيديو',
      heritage_field: 'التراث',
      science: 'العلوم',
      studies: 'الدراسات والبحوث',
      training: 'التدريب وبناء القدرات',
      culture: 'الثقافة',
      environment: 'البيئة والسياحة',
      tangible: 'التراث المادي',
      intangible: 'التراث اللامادي',
      lang: 'English',
    },

    hero: {
      title: 'منظمة تراث اليمن لأجل السلام',
      subtitle: 'نحافظ على الإرث الحضاري اليمني ونبني جسور السلام',
      desc: 'منظمة مجتمع مدني تعمل على الحفاظ على التراث الثقافي والعلمي اليمني من خلال برامج تعليمية وفعاليات ثقافية وبحوث علمية',
      btn1: 'اكتشف أعمالنا',
      btn2: 'تواصل معنا',
    },

    stats: {
      projects: 'مشروع منجز',
      partners: 'شركاء محليون ودوليون',
      events: 'فعالية وندوة',
      years: 'سنوات خبرة',
    },

    about_short: {
      title: 'من نحن',
      desc: 'منظمة مجتمع مدني غير حكومية تعمل على الحفاظ على التراث الثقافي والعلمي اليمني، وتعزيز الوعي المجتمعي به من خلال برامج تعليمية، فعاليات ثقافية، وبحوث علمية تربط الماضي بالحاضر لبناء مستقبل سلمي ومستدام.',
      more: 'اقرأ المزيد',
    },

    vision: 'الرؤية',
    mission: 'الرسالة',
    goals: 'الأهداف',
    values: 'القيم',

    vision_text:
      'بناء مجتمع يمني مزدهر يحتفي بتراثه الغني، يعزز السلام من خلال العلوم والثقافة، ويبني جسور التواصل بين الأجيال والشعوب.',
    mission_text:
      'تعزيز التراث اليمني في مجالات الثقافة والعلوم من خلال برامج بحثية وعملية تربط الماضي بالمستقبل، لدعم السلام والاستقرار الاجتماعي والاقتصادي في اليمن.',

    partners_title: 'شركاؤنا',
    latest_news: 'آخر الأخبار',
    latest_events: 'الفعاليات القادمة',
    read_more: 'اقرأ المزيد',
    view_all: 'عرض الكل',

    contact_title: 'تواصل معنا',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    address: 'العنوان',
    address_val: 'تعز، اليمن',
    name_field: 'الاسم',
    msg_field: 'الرسالة',
    send: 'إرسال',

    footer_desc: 'منظمة مجتمع مدني تعمل على الحفاظ على التراث الثقافي اليمني وتعزيز السلام.',
    rights: 'جميع الحقوق محفوظة',

    fields_title: 'مجالات عملنا',
    fields_desc: 'نعمل في مجالات متعددة تخدم التراث والعلوم والثقافة والبيئة',

    heritage_life_title: 'تراثنا حياة',
    tangible_desc: 'صون وتوثيق المواقع والمباني والمقتنيات التاريخية',
    intangible_desc: 'حفظ الموروث الشفهي والممارسات التقليدية والفنون',

    no_items: 'لا توجد عناصر حتى الآن',
    no_results: 'لا توجد نتائج',
    loading: 'جارٍ التحميل...',
    saving: 'جارٍ الحفظ...',
    notSet: 'غير محدد',

    gallery: 'المعرض',
    gallery_title: 'المعرض',
    manage_gallery: 'إدارة المعرض',
    add_gallery_item: 'إضافة عنصر',
    edit_gallery_item: 'تعديل عنصر المعرض',
    photo_gallery_title: 'معرض الصور',
    photo_gallery_subtitle:
      'مساحة بصرية توثق أنشطة المنظمة ومبادراتها ومشاركاتها المجتمعية.',
    video_gallery_title: 'معرض الفيديو',
    video_gallery_subtitle:
      'مقاطع مرئية توثق الفعاليات والمشاريع والأنشطة المعرفية والثقافية.',
    photo: 'صورة',
    photos: 'الصور',
    video: 'فيديو',
    videos: 'الفيديو',
    all: 'الكل',
    preview: 'معاينة',
    item_type: 'نوع العنصر',
    gallery_image: 'صورة المعرض',
    video_thumbnail: 'صورة مصغرة للفيديو',
    video_url: 'رابط الفيديو',
    sort_order: 'الترتيب',
    order: 'الترتيب',
    active: 'نشط',
    hidden: 'مخفي',
    show_on_website: 'إظهار في الموقع',
    no_photos: 'لا توجد صور متاحة حاليًا.',
    no_videos: 'لا توجد فيديوهات متاحة حاليًا.',
    no_gallery_items: 'لا توجد عناصر في المعرض',
    loading_photos: 'جارٍ تحميل الصور...',
    loading_videos: 'جارٍ تحميل الفيديوهات...',
    not_found_title: 'الصفحة غير موجودة',
    not_found_desc: 'عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها.',
    back_home: 'العودة للرئيسية',

    admin_login: 'تسجيل الدخول للإدارة',
    username: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    login: 'دخول',
    logout: 'خروج',
    dashboard: 'لوحة التحكم',
    manage_news: 'إدارة الأخبار',
    manage_events: 'إدارة الفعاليات',
    manage_admins: 'إدارة المشرفين',
    add_new: 'إضافة جديد',
    save: 'حفظ',
    saving: 'جارٍ الحفظ...',
    cancel: 'إلغاء',
    error: 'خطأ',
    relatedMedia: 'الوسائط المرتبطة',
    photosVideos: 'الصور والفيديو',
    viewAllMedia: 'عرض كل الوسائط',
    mediaCount: 'عنصر',
    noMedia: 'لا توجد وسائط',
    delete: 'حذف',
    edit: 'تعديل',
    title_field: 'العنوان',
    content_field: 'المحتوى',
    date_field: 'التاريخ',
    image_field: 'رابط الصورة',
    category_field: 'التصنيف',
    add_admin: 'إضافة مشرف',
    change_password: 'تغيير كلمة المرور',
    new_password: 'كلمة المرور الجديدة',
    confirm_password: 'تأكيد كلمة المرور',
    profile: 'الملف الشخصي',
    welcome: 'مرحباً',

    goals_list: [
      'الإسهام في تطوير التعليم وبناء نظام تعليمي وبحثي مستدام يواكب متطلبات العصر ويعزز السلام والتعاون الدولي عبر التربية والثقافة والعلوم.',
      'الإسهام في حماية وصون وإحياء الموروث الثقافي وحماية حقوق الملكية الفكرية للتراث الثقافي اليمني والعمل على تعزيز الثقافة الوطنية والقدرة الإبداعية الفنية والأدبية.',
      'الإسهام الفعال في الحفاظ على البيئة وحمايتها من التلوث والتدهور البيئي والتأثيرات السلبية لتغير المناخ.',
      'السعي لإقامة تنمية سياحية مستدامة تحقق فوائد اقتصادية واجتماعية ومعرفية مع ضمان المساواة بين الجنسين.',
      'المساهمة الفعالة إلى جانب الشركاء المحليين والدوليين في تحقيق أهداف التنمية المستدامة.',
    ],
  },

  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      news: 'News',
      media_center: 'Media Center',
      mediaCenter: 'Media Center',
      activities: 'Activities & Events',
      events_activities: 'Events & Activities',
      eventsActivities: 'Events & Activities',
      fields: 'Our Fields',
      heritage_life: 'Heritage is Life',
      contact: 'Contact Us',
      admin: 'Admin',
      events: 'Events',
      seminars: 'Seminars',
      projects: 'Projects',
      gallery: 'Gallery',
      photo_gallery: 'Photo Gallery',
      photoGallery: 'Photo Gallery',
      video_gallery: 'Video Gallery',
      videoGallery: 'Video Gallery',
      heritage_field: 'Heritage',
      science: 'Sciences',
      studies: 'Studies & Research',
      training: 'Training & Capacity Building',
      culture: 'Culture',
      environment: 'Environment & Tourism',
      tangible: 'Tangible Heritage',
      intangible: 'Intangible Heritage',
      lang: 'عربي',
    },

    hero: {
      title: 'Yemen Heritage for Peace Organization',
      subtitle: 'Preserving Yemeni Cultural Legacy, Building Bridges for Peace',
      desc: 'A civil society organization dedicated to preserving Yemeni cultural and scientific heritage through educational programs, cultural events, and scientific research.',
      btn1: 'Explore Our Work',
      btn2: 'Contact Us',
    },

    stats: {
      projects: 'Completed Projects',
      partners: 'Local & International Partners',
      events: 'Events & Seminars',
      years: 'Years of Experience',
    },

    about_short: {
      title: 'Who We Are',
      desc: 'A non-governmental civil society organization working to preserve Yemeni cultural and scientific heritage, raising community awareness through educational programs, cultural events, and scientific research that connects past with present to build a peaceful and sustainable future.',
      more: 'Read More',
    },

    vision: 'Vision',
    mission: 'Mission',
    goals: 'Goals',
    values: 'Values',

    vision_text:
      'Building a prosperous Yemeni society that celebrates its rich heritage, promotes peace through science and culture, and builds bridges of communication between generations and peoples.',
    mission_text:
      'Strengthening Yemeni heritage in culture and science through research and practical programs that connect the past with the future, supporting peace and social-economic stability in Yemen.',

    partners_title: 'Our Partners',
    latest_news: 'Latest News',
    latest_events: 'Upcoming Events',
    read_more: 'Read More',
    view_all: 'View All',

    contact_title: 'Contact Us',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    address_val: 'Taiz, Yemen',
    name_field: 'Name',
    msg_field: 'Message',
    send: 'Send',

    footer_desc: 'A civil society organization working to preserve Yemeni cultural heritage and promote peace.',
    rights: 'All Rights Reserved',

    fields_title: 'Our Fields of Work',
    fields_desc: 'We work across multiple fields serving heritage, science, culture, and environment',

    heritage_life_title: 'Heritage is Life',
    tangible_desc: 'Preserving and documenting historical sites, buildings, and artifacts',
    intangible_desc: 'Preserving oral heritage, traditional practices, and arts',

    no_items: 'No items yet',
    no_results: 'No results found',
    loading: 'Loading...',
    saving: 'Saving...',
    notSet: 'Not set',

    gallery: 'Gallery',
    gallery_title: 'Gallery',
    manage_gallery: 'Manage Gallery',
    add_gallery_item: 'Add Item',
    edit_gallery_item: 'Edit Gallery Item',
    photo_gallery_title: 'Photo Gallery',
    photo_gallery_subtitle:
      'A visual space documenting the organization’s activities, initiatives, and community engagement.',
    video_gallery_title: 'Video Gallery',
    video_gallery_subtitle:
      'Videos documenting events, projects, and cultural and knowledge-based activities.',
    photo: 'Photo',
    photos: 'Photos',
    video: 'Video',
    videos: 'Videos',
    all: 'All',
    preview: 'Preview',
    item_type: 'Item Type',
    gallery_image: 'Gallery Image',
    video_thumbnail: 'Video Thumbnail',
    video_url: 'Video URL',
    sort_order: 'Order',
    order: 'Order',
    active: 'Active',
    hidden: 'Hidden',
    show_on_website: 'Show on website',
    no_photos: 'No photos are available yet.',
    no_videos: 'No videos are available yet.',
    no_gallery_items: 'No gallery items found',
    loading_photos: 'Loading photos...',
    loading_videos: 'Loading videos...',
    not_found_title: 'Page Not Found',
    not_found_desc: 'Sorry, the page you are looking for does not exist or has been moved.',
    back_home: 'Back to Home',

    admin_login: 'Admin Login',
    username: 'Email',
    password: 'Password',
    login: 'Login',
    logout: 'Logout',
    dashboard: 'Dashboard',
    manage_news: 'Manage News',
    manage_events: 'Manage Events',
    manage_admins: 'Manage Admins',
    add_new: 'Add New',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    error: 'Error',
    relatedMedia: 'Related Media',
    photosVideos: 'Photos & Videos',
    viewAllMedia: 'View All Media',
    mediaCount: 'items',
    noMedia: 'No media available',
    delete: 'Delete',
    edit: 'Edit',
    title_field: 'Title',
    content_field: 'Content',
    date_field: 'Date',
    image_field: 'Image URL',
    category_field: 'Category',
    add_admin: 'Add Admin',
    change_password: 'Change Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    profile: 'Profile',
    welcome: 'Welcome',

    goals_list: [
      'Contributing to developing education and building a sustainable, inclusive educational and research system that keeps up with modern requirements and promotes peace through education, culture, and science.',
      'Contributing to protecting, preserving, and reviving cultural heritage and protecting intellectual property rights of Yemeni cultural heritage.',
      'Actively contributing to environmental conservation and protecting against pollution, environmental degradation, and negative impacts of climate change.',
      'Seeking to establish sustainable tourism development that achieves economic, social, and knowledge benefits while ensuring gender equality.',
      'Actively contributing alongside local and international partners to achieve sustainable development goals.',
    ],
  },
}
